module.exports = __webpack_public_path__ + "media/images/icons/filled/mac-command-f1a41e04692f24557c601dbda136e805.svg";